export const breakpoints = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 1025,
  xl: 1200,
  xxl: 1400,
  xxxl: 1920,
  xl2k: 2560,
  xl4k: 3840,
}

export const breakpointsArray = Object.keys(breakpoints)
